import React from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { ProfileMessageInput, useProfileMessagingState } from '../../../../shared/ProfileMessaging';
import { RouteProp } from '@react-navigation/native';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import { getIntl } from '../../../../../utils/intl';
import ProfileHeaderContainer from '../../../../v2BaseComponents/ProfileHeaderContainer';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';

const intl = getIntl('message-profile-screen', {
    send: 'Send',
    cancel: 'Cancel',
});

export type MessageProfileScreenOwnProps = {};

export type MessageProfileScreenProps = MessageProfileScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'message-profile'>;
};

const MessageProfileScreen: React.FC<MessageProfileScreenProps> = (props) => {
    const goBack = useGoBack();
    const { onSend, isSendDisabled, message, setMessage, onCancel } = useProfileMessagingState({
        onCancel: goBack,
        onClose: goBack,
        selectedProfileIds: [props.route.params.profileId],
    });

    return (
        <ProfileHeaderContainer profileId={props.route.params.profileId} bottomBorder omitChatButton>
            <ActionButtonLayout
                whiteBackground
                actions={[
                    {
                        title: intl('cancel'),
                        icon: 'XCircle',
                        onPress: onCancel,
                        variant: 'secondary',
                        testID: 'cancel-add-message',
                    },
                    {
                        title: intl('send'),
                        icon: 'Send',
                        onPress: onSend,
                        isDisabled: isSendDisabled,
                        testID: 'submit-add-message',
                    },
                ]}
            >
                <MainContentContainer style={{ width: '100%', height: '100%' }}>
                    <ProfileMessageInput
                        selectedProfileIds={[props.route.params.profileId]}
                        message={message}
                        setMessage={setMessage}
                        type="profile"
                    />
                </MainContentContainer>
            </ActionButtonLayout>
        </ProfileHeaderContainer>
    );
};

export default React.memo(MessageProfileScreen);
